import * as THREE from 'three';
import { BINS, type BinId } from '../../data/bins';

/**
 * A tappable 3D bin — `userData.binId` is how SortingStation's raycaster resolves a tap
 * back to a BinId, so every mesh in the returned group must carry it.
 */
export function createBin3D(binId: BinId, position: THREE.Vector3): THREE.Group {
  const bin = BINS[binId];
  const group = new THREE.Group();
  group.userData.binId = binId;

  const bodyMaterial = new THREE.MeshStandardMaterial({ color: bin.color, roughness: 0.6 });
  const body = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.36, 0.62, 16), bodyMaterial);
  body.position.y = 0.31;
  body.userData.binId = binId;
  group.add(body);

  const rimMaterial = new THREE.MeshStandardMaterial({ color: bin.color, roughness: 0.4 });
  const rim = new THREE.Mesh(new THREE.TorusGeometry(0.42, 0.045, 8, 20), rimMaterial);
  rim.rotation.x = Math.PI / 2;
  rim.position.y = 0.62;
  rim.userData.binId = binId;
  group.add(rim);

  group.position.copy(position);
  return group;
}

/** All raycastable meshes inside a Bin3D group — used to build the SortingStation's pick list. */
export function bin3DPickables(bin: THREE.Group): THREE.Object3D[] {
  const pickables: THREE.Object3D[] = [];
  bin.traverse((child) => {
    if (child instanceof THREE.Mesh) pickables.push(child);
  });
  return pickables;
}

export function disposeBin3D(bin: THREE.Group): void {
  bin.traverse((child) => {
    if (child instanceof THREE.Mesh) {
      child.geometry.dispose();
      if (Array.isArray(child.material)) child.material.forEach((m) => m.dispose());
      else child.material.dispose();
    }
  });
}
